import { CustomerHistory } from "../../types/apimodel";

export interface HeadCell {
    disablePadding: boolean;
    id: keyof CustomerHistory;
    label: string;
    labelShort : string;
    numeric: boolean,
    visibleSm: boolean,
    visibleXs: boolean,
    visibleMd: boolean,
    width: string
}

export const HeadCells: readonly HeadCell[] = [
    /*
    {
        id: 'tenant',
        numeric: false,
        disablePadding: true,
        label: 'Mandant',
        visibleXs: true,
        visibleSm: true,
        visibleMd: true,
    },
    */
    {
        id: 'erstelldatum',
        numeric: false,
        disablePadding: true,
        label: 'Datum',
        labelShort: 'Datum',
        visibleXs: false,
        visibleSm: false,
        visibleMd: true,
        width: '110px'
    },
    {
        id: 'sparte',
        numeric: false,
        disablePadding: true,
        label: 'Sparte',
        labelShort: 'Sparte',
        visibleXs: false,
        visibleSm: false,
        visibleMd: true,
        width: '110px'
    },
    {
        id: "vsnr",
        numeric: false,
        disablePadding: true,
        label: 'Dokument',
        labelShort: 'Dokument',
        visibleXs: false,
        visibleSm: false,
        visibleMd: true,
        width: 'auto'
    },
    {
        id: "risiko",
        numeric: false,
        disablePadding: true,
        label: 'Details zum Vertrag',
        labelShort: 'Details',
        visibleXs: false,
        visibleSm: false,
        visibleMd: true,
        width: 'auto'
    }
    
];


export interface DashboardReportRowHeadCell {
    id: keyof CustomerHistory,
    disablePadding: boolean,
    label: string,
    numeric: boolean,
    date: boolean,
    visibleInCompact: boolean
}

export interface KeyValueReportRowHeadCell {
    id: string,
    disablePadding: boolean,
    label: string,
    numeric: boolean,
    date: boolean,
    visibleInCompact: boolean
}

// export const detailTableRumpfHeaders: readonly DashboardReportRowHeadCell[] = [
//     {
//         id: 'authorUserid',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'UserID Ersteller',
// 		visibleInCompact: true
// 	},
//     {
//         id: 'id',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Datenbank-ID (Entwicklersicht)',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'extid',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'ID nach außen (Kundensicht)',
// 		visibleInCompact: true
// 	},
//     {
//         id: 'shortId',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'ID Kurz-URL (Kundensicht)',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'authtype',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Authentifizierungstyp',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'firstname',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Kunde Vorname',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'lastname',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Kunde Nachname',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'tenant',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Mandant',
// 		visibleInCompact: true
// 	},
//     {
//         id: 'templateExternalid',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Vorlage',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'contact',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Kontakt Kunde',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'contactBy',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Kontaktart',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'brokerno',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Vermittler',
// 		visibleInCompact: true
// 	},
//     {
//         id: 'created',
//         date: true,
//         numeric: false,
//         disablePadding: true,
//         label: 'Erstellt',
// 		visibleInCompact: true
// 	},
//     {
//         id: 'countFailed',
//         date: false,
//         numeric: true,
//         disablePadding: true,
//         label: 'Anzahl fehlerhafte Authentifizierung',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'deleted',
//         date: false,
//         numeric: false,
//         disablePadding: true,
//         label: 'Löschkennzeichen',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'firstOpened',
//         numeric: false,
//         date: true,
//         disablePadding: true,
//         label: 'Erstmals geöffnet am',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'firstOpenedPreauth',
//         numeric: false,
//         date: true,
//         disablePadding: true,
//         label: 'Erstmals geöffnet (unauthentifiziert)',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'validfrom',
//         numeric: false,
//         date: true,
//         disablePadding: true,
//         label: 'Gültig ab',
// 		visibleInCompact: true
// 	},
//     {
//         id: 'validuntil',
//         numeric: false,
//         date: true,
//         disablePadding: true,
//         label: 'Gültig bis',
// 		visibleInCompact: true
// 	},
//     {
//         id: 'lastFailed',
//         numeric: false,
//         date: true,
//         disablePadding: true,
//         label: 'Letzte fehlerhafte Authentifizierung',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'marketingcampaign',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Marketingkampagne',
// 		visibleInCompact: true
// 	},
//     {
//         id: 'personalizationLevel',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Linkart (Individuell / Gruppe / Öffentlich)',
// 		visibleInCompact: true
// 	},
//     {
//         id: 'shortlinkcampaign',
//         numeric: false,
//         date: false,
//         disablePadding: true,
//         label: 'Kurzlink-Kampagne',
// 		visibleInCompact: false
// 	},
//     {
//         id: 'firstCompleted',
//         numeric: false,
//         date: true,
//         disablePadding: true,
//         label: 'Erstmals fertig bearbeitet am',
// 		visibleInCompact: false
//     }
// ];

